<section class="ui modal">
  <i class="close icon"> <svg   data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.01 30.01"><path d="M16.38 15.01L29.73 1.66A1 1 0 0 0 28.36.29L15.01 13.64 1.66.29A1 1 0 0 0 .29 1.66l13.35 13.35L.29 28.36a1 1 0 0 0 1.37 1.37l13.35-13.35 13.35 13.35a1 1 0 0 0 1.37-1.37z" fill="#757575" fill-rule="evenodd"/></svg> </i>
  <div data-e2e="title" class="header" i18n>Share Status for Dispatch #{{dispatch?.orderNumber}}</div>

  <div class="content">
    <ng-container i18n>Send a tracking link for this dispatch to someone so they can follow the progress in real-time.</ng-container>
    <div [class.invalid]="!emailControl?.valid && isSubmitted" class="email">
      <label i18n>Email</label>
      <div class="ui form">
        <form>
          <div class="ui input">
            <input [class.error]="!emailControl?.valid && isSubmitted" type="email" [formControl]="emailControl"
              placeholder="john@example.com" />
            <button [ngClass]="{'blue': !sendingEmail, 'loading': sendingEmail}" (click)="shareDetail($event)"
              type="button" class="ui button" i18n>
              Send
            </button>
          </div>
          <form-error [control]="emailControl" [hidden]="emailControl?.valid || !isSubmitted">
            <form-error-message type="required" i18n>Enter a valid email address</form-error-message>
            <form-error-message type="deliverable" i18n>Email is not deliverable</form-error-message>
            <form-error-message type="invalid" i18n>Email format is invalid</form-error-message>
          </form-error>
        </form>
      </div>
    </div>
  </div>

  <div class="share-url">
    <label i18n>Share URL Directly</label>
    <div class="ui large input">
      <input type="text" [ngModel]="dispatch?.trackingURL" disabled />
      <button (click)="onCopyClick($event)" type="button" class="ui button" i18n>
        Copy
      </button>
    </div>
  </div>
</section>
